import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { filterModel } from './filterModel';
import { EndPointConstant } from 'src/app/core/constants/endpoint.constants';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  setDesignationId(designationId: string) : void{
    localStorage.setItem('designationId', designationId )
  }

  getDesignationId() : string | null{
    const designationId = localStorage.getItem('designationId');
    if(designationId != null){
      return designationId;
    }else{
      return null;
    }
     
  }

  setCourseId(courseId: string) : void{
    localStorage.setItem('courseId', courseId )
  }

  getCourseId() : string | null{
    const courseId = localStorage.getItem('courseId');
    if(courseId != null){
      return courseId;
    }else{
      return null;
    }
     
  }

  constructor(private http:HttpClient) { }

   getAllDashboardCounts(filterModel: filterModel | undefined): Observable<number>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllDashboardCounts()}`+ '?' + this.encodeQueryData(filterModel));
  }
  
  getDesignationCount(filterModel: filterModel | undefined): Observable<number>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllDesignationsCount()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getCoursesCount(filterModel: filterModel | undefined): Observable<number>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllCoursesCount()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getEmployeesCount(filterModel: filterModel | undefined): Observable<number>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllEmployeesCount()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getInstructorsCount(filterModel: filterModel | undefined): Observable<number>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllInstructorsCount()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getDesignationWiseCoursesAndEmployees(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationWiseCoursesAndEmployees()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getDesignationWiseCoursesAndEmployeesByDesignationId(designationId : string, filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationWiseCoursesAndEmployees()}${designationId}` + '?' + this.encodeQueryData(filterModel));
  }
 
  getDesigntionWiseCoursesList(designationId : string, filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetCoursesList()}${designationId}` + '?' + this.encodeQueryData(filterModel));
  }

  getCourseWiseEmployeesList(designationId : string,  courseId:string,  filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeesList()}${designationId}/${courseId}` + '?' + this.encodeQueryData(filterModel));
  }

  getCourseCompletionStatus(designationId : string,  courseId:string,  filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetCourseCompletionStatus()}${designationId}/${courseId}`+ '?' + this.encodeQueryData(filterModel));
  }

  getDesignationLevelStatus(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationLevelStatus()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getDesignationAndCoursesList(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationAndCoursesList()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getCoursesNamesList(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllCoursesNamesList()}`+ '?' + this.encodeQueryData(filterModel));
  }

  getAllEmployeesNamesList(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllEmployeesNamesList()}`+ '?' + this.encodeQueryData(filterModel));
  }
  getEmployeesDetail(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeDetail()}` + '?' + this.encodeQueryData(filterModel));
  }
   getCoursesDetail(filterModel : filterModel): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetCourseDetail()}` + '?' + this.encodeQueryData(filterModel));
  }
  getDesignationsDetail(filterModel : filterModel): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationDetail()}` + '?' + this.encodeQueryData(filterModel));
  }
  getInstructorsDetail(filterModel : filterModel): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetInstructorDetail()}` + '?' + this.encodeQueryData(filterModel));
  }
  getDashboardAllCounts(filterModel : filterModel ): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDashboardAllCounts()}` + '?' + this.encodeQueryData(filterModel));
  }

  getDesignationWiseCourseEnrollments(filterModel : filterModel ): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationWiseCourseEnrollments()}` + '?' + this.encodeQueryData(filterModel));
  }

  getAllInstructorsNamesList(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllInstructorsNamesList()}`+ '?' + this.encodeQueryData(filterModel));
  }
  getEmployeeStatusByDesignationAndCourseId(designationId : string,  courseId:string,  filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeStatusByDesignationAndCourseId()}${designationId}/${courseId}` + '?' + this.encodeQueryData(filterModel));
  }
  getDesignationWiseEmployeeStatusList(filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDesignationWiseEmployeeStatusList()}` + '?' + this.encodeQueryData(filterModel));
  }
  getEmployeeWiseEnrollments(filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeWiseEnrollments()}` + '?' + this.encodeQueryData(filterModel));
  }
  getEmployeeStatusByEmployeeId(employeeId : string,  filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeStatusByEmployeeId()}${employeeId}` + '?' + this.encodeQueryData(filterModel));
  }
  getEmployeeStatusByCourseId(courseId : string,  filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeStatusByCourseId()}${courseId}` + '?' + this.encodeQueryData(filterModel));
  }
  getAllEmployeesDetailList(filterModel: filterModel | undefined): Observable<any>{
    
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllEmployeesDetailList()}` + '?' + this.encodeQueryData(filterModel));
  }
  getCourseEnrollments(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetCourseEnrollments()}` + '?' + this.encodeQueryData(filterModel));
  }
  getAssignedCoursesDetailsByEmployeeId(employeeId : string,  filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAssignedCoursesDetailsByEmployeeId()}${employeeId}` + '?' + this.encodeQueryData(filterModel));
  }
  getEnrolledCoursesDetailsByEmployeeId(employeeId : string,  filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEnrolledCoursesDetailsByEmployeeId()}${employeeId}` + '?' + this.encodeQueryData(filterModel));
  }
  getCompletedCoursesDetailsByEmployeeId(employeeId : string,  filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetCompletedCoursesDetailsByEmployeeId()}${employeeId}` + '?' + this.encodeQueryData(filterModel));
  }
  getEmployeeWiseCourseDetailCompleteData(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetEmployeeWiseCourseDetailCompleteData()}` + '?' + this.encodeQueryData(filterModel));
  }

  // filter drop down APIs

  getAllDesignations() : Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.Designation.GetDesignations()}`);
  }

  getAllCourses(): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllCourses()}`);
  }

  getAllCourseModules(): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllCourseModules()}`);
  }
  getAllCourseSubModules(filterModel: filterModel | undefined): Observable<any>{ 
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetAllCourseSubModules()}` + '?' + this.encodeQueryData(filterModel));
  }
  getAllDivisions(provinceId? : number): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDivisions()}` +  (provinceId ? `?${this.encodeQueryData({ provinceId })}` : ''));
  }

  GetAllDistricts(divisionId? : number): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetDistricts()}` +  (divisionId ? `?${this.encodeQueryData({ divisionId })}` : ''));
  }

  GetAllTehsils(districtId? : number): Observable<any>{

    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetTehsils()}` +  (districtId ? `?${this.encodeQueryData({ districtId })}` : ''));

  }
   GetAllHealthFacilities(divisionId? : number, districtId? : number, tehsilId?: number): Observable<any>{
    const params = {
      divisionId,
      districtId,
      tehsilId
    };

    const queryParams = this.encodeQueryData(params);
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetHealthFacilities()}` +  (queryParams ? `?${ queryParams }` : ''));

  }
  // Get Users and Courses for filter
  getFilteredUsers(filterModel: filterModel | undefined): Observable<any>{
    return this.http.get<any>(`${environment.apiURL}${EndPointConstant.AdminDashboard.GetFilteredUsers()}` + '?' + this.encodeQueryData(filterModel));
  }
  // Add this method for User and Courses Report
  getUserAndCoursesReport(filterModel: filterModel): Observable<any> {
    return this.http.get<any>(
      `${environment.apiURL}${EndPointConstant.AdminDashboard.GetUserAndCoursesReport()}` + '?' + this.encodeQueryData(filterModel)
    );
  }
  encodeQueryData(data: any) {
    const ret = [];
    for (let d in data)
    {
      if(data[d] != undefined)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
  }

}
